import { FC } from 'react'
import { Spin } from 'antd'
import { ErrorNotFound, ErrorPermissionDenied, ErrorNoData, ErrorQuery } from '../../../routes/ErrorPages'
import PerFlexRow from '../FlexRow'
import BackgroundBox from '../BackgroundBox'
import PerSpacer from '../Spacer'
import { ApolloError } from '@apollo/client'

type LoadingAndErrorsProps = {
  isLoading: boolean
  hasNoData?: boolean
  showSpinner?: boolean
  error?: ApolloError
  isPermissionDenied?: boolean
}

export const LoadingAndErrors: FC<LoadingAndErrorsProps> = ({ isLoading, hasNoData, showSpinner, error, isPermissionDenied }) => {
  const notFoundError =
    error &&
    error.graphQLErrors &&
    error.graphQLErrors.length &&
    error.graphQLErrors.length > 0 &&
    error.graphQLErrors[0].extensions &&
    error.graphQLErrors[0].extensions.errorKey === 'entity.not.found'

  // todo: morph into one single "error page" printing graphql error messages
  const permissionDeniedError =
    error &&
    error.graphQLErrors &&
    error.graphQLErrors.length &&
    error.graphQLErrors.length > 0 &&
    error.graphQLErrors[0].extensions &&
    error.graphQLErrors[0].extensions.errorKey.includes('permission.not.granted')

  return (
    <>
      {isLoading ? (
        <PerFlexRow align="middle" justify="center" className="fullHeight">
          {!!showSpinner && <Spin size="large" spinning={isLoading} />}
        </PerFlexRow>
      ) : (
        <BackgroundBox r color="white" className="fullWidth fullHeight">
          <PerFlexRow align="middle" justify="center" className="fullHeight">
            <PerSpacer mb="l">
              {((hasNoData && !error) || isPermissionDenied) && <ErrorNoData />}
              {!!error && notFoundError && <ErrorNotFound />}
              {!!error && permissionDeniedError && <ErrorPermissionDenied />}
              {!!error && !notFoundError && !permissionDeniedError && <ErrorQuery />}
            </PerSpacer>
          </PerFlexRow>
        </BackgroundBox>
      )}
    </>
  )
}
